export const DEVELOPER_ROLE = { role: "DEV", roleName: "Developer" };

export const CSR_ROLE = {
  role: "CSR",
  roleName: "Customer Service Representative",
};

export const ACCOUNTING_ROLE = { role: "ACCOUNTING", roleName: "Accounting" };
